import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { BackWithOptionsHeader, PageTemplate } from '@_widgets/common';
import {
	ContentList,
	ContentListEditNavigationBar,
	LogoHeader,
	TitleHeader,
} from '@_widgets/folder';

import {
	useContentListAction,
	useContentListDeletePopup,
	useContentListFolderUpdateModal,
} from '@_features/content';
import { useFolderAction, useFolderOptionsModal } from '@_features/folder';

import { MetaTagWrapper } from '@_shared/ui/MetaTagWrapper';
import { Typography } from '@_shared/ui/Typography';

export function FolderPage() {
	const { id } = useParams();

	const { getFolderName } = useFolderAction();
	const folderName = getFolderName(Number(id));

	const [isEditMode, setIsEditMode] = useState(false);
	const { selectedContentIds, selectedFolderIds, dispatch } = useContentListAction();

	function closeEditMode() {
		setIsEditMode(false);
	}

	const { openFolderOptionsModal } = useFolderOptionsModal({
		folderId: String(id),
	});

	const { openContentListDeletePopup } = useContentListDeletePopup(
		selectedContentIds,
		dispatch,
		closeEditMode,
	);

	const { openContentListFolderUpdateModal } = useContentListFolderUpdateModal(
		dispatch,
		selectedFolderIds,
		closeEditMode,
	);

	function isAllFolderPage() {
		return id === 'all';
	}

	useEffect(() => {
		if (!isAllFolderPage()) {
			window.scrollTo(0, 0);
		}
	}, []);

	return (
		<MetaTagWrapper title={`폴더-${isAllFolderPage() ? '전체' : folderName}`}>
			<PageTemplate
				header={
					// eslint-disable-next-line no-nested-ternary
					isAllFolderPage() ? (
						<LogoHeader />
					) : isEditMode ? (
						<TitleHeader>
							<Typography type="title-large" color="font-primary">
								{folderName}
							</Typography>
						</TitleHeader>
					) : (
						<BackWithOptionsHeader onOptionsClick={openFolderOptionsModal}>
							<Typography type="title-large" color="font-primary">
								{folderName}
							</Typography>
						</BackWithOptionsHeader>
					)
				}
				nav={
					isEditMode ? (
						<ContentListEditNavigationBar
							isActive={selectedContentIds.length > 0}
							openContentDeletePopup={openContentListDeletePopup}
							openContentListFolderUpdateModal={openContentListFolderUpdateModal}
						/>
					) : (
						true
					)
				}
			>
				<ContentList
					isAllFolderPage={isAllFolderPage()}
					isEditMode={isEditMode}
					setIsEditMode={setIsEditMode}
					selectedContentIds={selectedContentIds}
					dispatch={dispatch}
				/>
			</PageTemplate>
		</MetaTagWrapper>
	);
}
